import Column from "theme/layouts/Column";
import React from "react";
import TextStyles from "theme/components/text/TextStyles";
import Wysiwyg from "theme/libs/wordpress/components/Wysiwyg";
import decodeHTMLEntities from "core-web/utils/decodeHTMLEntities";
import { useSelector } from "react-redux";

const CustomerServiceHero = ({ isOverViewPage = false }) => {
    const pageTitle = useSelector(({ page }) => page.data?.title);
    const heading = useSelector(({ page }) => page.data.heading?.heading || {});
    const description = useSelector(({ page }) => page.data.heading?.description || []);

    return (
        <Column gap={["32px", null, null, null, "24px"]}>
            <TextStyles
                as={heading?.type === "default" ? "h1" : heading.type || "h1"}
                textStyles={[
                    "Myriad Pro/40-110-semibold",
                    null,
                    null,
                    null,
                    isOverViewPage ? "Myriad Pro/64-110-semibold" : "Myriad Pro/48-120-semibold",
                ]}
            >
                {decodeHTMLEntities(heading?.text?.[0] || pageTitle)}
            </TextStyles>

            {!!description.length && (
                <Column gap="24px">
                    <Wysiwyg
                        data={description}
                        textComponent={(props) => (
                            <TextStyles
                                textStyles={["Myriad Pro/22-140", null, null, null, "Myriad Pro/20-140"]}
                                {...props}
                            />
                        )}
                    />
                </Column>
            )}
        </Column>
    );
};

export default CustomerServiceHero;
